import React from "react"
import { motion, AnimatePresence } from "framer-motion"

import { useScrollPosition } from "@n8tb1t/use-scroll-position"

// Commerce Context
import {
  useCartTotals,
  useCartItems,
  useCheckout,
  useToggleCart,
  useCloseCart,
  useStore,
} from "../../state/store"

// Svg
import CloseIcon from "../../svg/exit.svg"

import { LineItem } from "./lineItem"

export const CartFlyout = () => {
  const lineItems = useCartItems()
  const openCheckout = useCheckout()
  const toggleCart = useToggleCart()
  const closeCart = useCloseCart()
  const { total } = useCartTotals()
  const { cartIsOpen } = useStore()

  useScrollPosition(({ prevPos, currPos }) => {
    const isHide = currPos.y < prevPos.y
    if (isHide) closeCart()
  }, [])
  return (
    <AnimatePresence>
      {cartIsOpen && (
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          className="fixed top-4 right-gutter bg-white z-2000 w-fullGutter p-4 md:w-auto"
        >
          <header
            onClick={toggleCart}
            className="flex items-center justify-end pb-6"
          >
            <h2 className="font-display fill-current">Close</h2>
            <div className="w-4 ml-2 text-black">
              <CloseIcon />
            </div>
          </header>
          {lineItems.length > 0 ? (
            <article className="grid gap-y-6">
              {lineItems.map(item => (
                <div>
                  <LineItem {...item} />
                </div>
              ))}
            </article>
          ) : (
            <div>Cart is empty</div>
          )}
          <section className="border-t-2 border-dashed border-marphonaGold mt-6 pt-6">
            <div className="flex justify-between mb-2">
              <h2 className="font-bold text-base">Subtotal</h2>
              <h2 className="font-bold text-base">{total}</h2>
            </div>
            <div className="flex justify-between">
              <h2>Freight Included Nationwide</h2>
            </div>
          </section>
          <div className="flex justify-end mt-6">
            <button onClick={openCheckout} className="font-display text-xl">
              Checkout
            </button>
          </div>
        </motion.div>
      )}
      {cartIsOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          key="cartBg"
          className="fixed top-0 left-0 bg-black bg-opacity-30 w-full h-full block z-50"
        />
      )}
    </AnimatePresence>
  )
}
